export var FolderCardSize;
(function(FolderCardSize) {
    FolderCardSize["NANO"] = 'nano';
    FolderCardSize["TINY"] = 'tiny';
    FolderCardSize["SMALL"] = 'small';
    FolderCardSize["MEDIUM"] = 'medium';
    FolderCardSize["BIG"] = 'big';
})(FolderCardSize || (FolderCardSize = {}));
export const folderCardSizeBreakpoints = {
    [FolderCardSize.NANO]: 130,
    [FolderCardSize.TINY]: 220,
    [FolderCardSize.MEDIUM]: 300,
    [FolderCardSize.BIG]: 999
};
